import React, { Component } from 'react';
import 'react-h5-audio-player/lib/styles.css';
import AudioPlayer from 'react-h5-audio-player';


class SeamlessLoopPlayer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isPlaying: false,
            error: null,
        };

        // Свойства класса для хранения объектов Web Audio API (аналог useRef)
        this.audioContext = null;
        this.sourceNode = null;
        this.buffer = null;

        // Инициализируем аудиоконтекст
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        this.audioBuffer = null; // Здесь будет храниться декодированный файл
        this.sourceNode = null;  // Ссылка на текущий играющий узел

        this.state = {
            currentSpeed: 1.0,
            isPlaying: false
        };
    }

    // 1. Загрузка и декодирование аудио
    loadAndDecodeAudio = async () => {
        const { audioUrl } = this.props;
        try {
           // console.log(AUDIO_FILES[0].file);
            //const response = await fetch('https://static.roomab.art/mp3/kolan-kolanych-loopcdf49bc3aa58642fd00857f3d38c44b7.wav');
            const response = await fetch(this.props.elementData.file);
            console.log(this.props.elementData.file);
            const arrayBuffer = await response.arrayBuffer();

            // Инициализируем контекст при первом обращении
            if (!this.audioContext) {
                this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            }

            // Декодируем бинарные данные в аудио-буфер
            this.buffer = await this.audioContext.decodeAudioData(arrayBuffer);
        } catch (error) {
            console.error('Ошибка загрузки или декодирования аудио:', error);
            this.setState({ error: 'Не удалось загрузить аудиофайл' });
        }
    };

    // 2. Старт воспроизведения лупа
    startLoop = async () => {
        // Если аудио еще не загружено, загружаем его
        if (!this.audioContext) {
            await this.loadAndDecodeAudio();
        }

        if (!this.buffer || !this.audioContext) return;

        // Возобновляем контекст, если браузер его приостановил
        if (this.audioContext.state === 'suspended') {
            await this.audioContext.resume();
        }

        // Создаем ноду источника (пересоздается при каждом запуске)
        const source = this.audioContext.createBufferSource();
        source.buffer = this.buffer;
        source.loop = true; // Главное свойство для бесшовного зацикливания

        // Подключаем к выходу звуковой карты
        source.connect(this.audioContext.destination);

        // Запускаем немедленно
        source.start(0);

        // Сохраняем ссылку для остановки
        this.sourceNode = source;
        this.setState({ isPlaying: true });
    };

    // 3. Остановить воспроизведение
    stopLoop = () => {
        if (this.sourceNode) {
            try {
                this.sourceNode.stop();
            } catch (err) {
                // Игнорируем ошибку, если нода уже была остановлена
            }
            this.sourceNode = null;
        }
        this.setState({ isPlaying: false });
    };

    // Динамическое изменение скорости (без перезапуска трека!)
    changeSpeed = (speed) => {
        this.setState({ currentSpeed: speed });

        // Если трек сейчас играет, скорость изменится мгновенно на лету
        if (this.sourceNode) {
            this.sourceNode.playbackRate.value = speed;
        }
    };

    // 4. Очистка ресурсов при уничтожении компонента (аналог useEffect cleanup)
    componentWillUnmount() {
        if (this.sourceNode) {
            try {
                this.sourceNode.stop();
            } catch (err) {}
        }
        if (this.audioContext) {
            this.audioContext.close();
        }
    }

    componentDidMount() {
        // Установка начальной скорости при загрузке (например, 1.2x)
        this.changeSpeed(1.2);
    }

    render() {
        const { isPlaying, error } = this.state;

        if (error) {
            return <div style={{ color: 'red' }}>Ошибка: {error}</div>;
        }

        return (
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                {!isPlaying ? (
                    <button onClick={this.startLoop}>▶ {this.props.elementData.name}</button>
                ) : (
                    <button onClick={this.stopLoop}>⏹ Остановить</button>
                )}
                <button onClick={() => this.changeSpeed(0.5)}>0.5x</button>
                <button onClick={() => this.changeSpeed(1.0)}>1.0x (Обычная)</button>
                <button onClick={() => this.changeSpeed(1.5)}>1.5x</button>
                <button onClick={() => this.changeSpeed(2.0)}>2.0x</button>
            </div>

        );
    }
}

export default SeamlessLoopPlayer;